module.exports = __webpack_public_path__ + "img/admin-login.e9240685.png";